export const data = {
  name: "Magesh B",
  role: "Front-End Developer",
  tagline: "Passionate Frontend Developer skilled in HTML, CSS, JavaScript and React.js. Focused on building responsive, clean and user-friendly web applications with strong UI/UX attention.",
  location: "TamilNadu, India",
  pincode: "605751",
  dob: "June 1999",
  email: "mageshvaran4006@gmail.com",
  email2: "mageshb4006@gmail.com",
  phone: "8870384006",
  github: "https://github.com/magesh-frontend",
  linkedin: "https://www.linkedin.com/in/mageshbalu-dev/",
  whatsapp: "https://wa.me/918870384006?text=Hi%20Magesh%20I%20saw%20your%20portfolio",
  instagram: "https://www.instagram.com/str_magesh006",
  resume: "/resume/Magesh_B_React_Developer_Resume.pdf",

  skills: [
    {
      category: "LANGUAGES",
      items: [
        { name: "HTML", img: "/skill/HTML-Logo.png" },
        { name: "CSS", img: "/skill/CSS-logo.png" },
        { name: "JavaScript", img: "/skill/javascript-logo.png" },
      ],
    },
    {
      category: "FRAMEWORKS",
      items: [
        { name: "Bootstrap", img: "/skill/Bootstrap-logo.png" },
        { name: "React", img: "/skill/reactjs-logo.png" },
        { name: "Tailwind CSS", img: "/skill/tailwindcss.png" },
      ],
    },
    {
      category: "TOOLS",
      items: [
        { name: "VS Code", img: "/skill/Vscode-logo.webp" },
        { name: "GitHub", img: "/skill/github-logo.png" },
        { name: "Photoshop", img: "/skill/Adobeps-logo.png" },
      ],
    },
  ],

  education: [
    {
      side: "left",
      year: "Year 2026",
      title: "JAVA FULLSTACK DEVELOPER",
      institution: "Besant Technologies, Bangalore.",
      detail: "Certified",
    },
    {
      side: "left",
      year: "Year 2014 - 2016",
      title: "SSLC & HSC",
      institution: "Government Hr sec School, Kallakurichi.",
      detail: "TamilNadu. Percentage : 64.8% & 53.75%",
    },
    {
      side: "right",
      year: "Year 2016 - 2019",
      title: "BSC COMPUTER SCIENCE",
      institution: "DR.R.K.Shanmugam College, Kallakurichi.",
      detail: "Percentage : 65.8%",
    },
  ],

  projects: [
    {
      title: "SUPERCART E-COMMERCE",
      tech: ["/skill/HTML-Logo.png", "/skill/CSS-logo.png", "/skill/javascript-logo.png", "/skill/reactjs-logo.png"],
     techNames: ["HTML", "CSS", "JavaScript", "React"],
      description: "Modern e-commerce application with responsive design, product browsing, cart management, and smooth shopping experience for users.",
      live: "https://supercart-git-main-magesh-frontends-projects.vercel.app/",
      github: "https://github.com/magesh-frontend/supercart-ecommerce"
    },
    {
      title: "CINE SEARCH APP",
      tech: ["/skill/HTML-Logo.png", "/skill/CSS-logo.png", "/skill/javascript-logo.png", "/skill/reactjs-logo.png"],
      techNames: ["HTML", "CSS", "JavaScript", "React"],
      description: "Movie search application with responsive UI and real-time search functionality. Browse, search and explore film details seamlessly.",
      live: "https://cinesearch-movie-app-zo85.vercel.app/",
      github: "https://github.com/magesh-frontend/cinesearch-movie-app"
    },
    {
      title: "SPENDLENS TRACKER",
      tech: ["/skill/HTML-Logo.png","/skill/reactjs-logo.png", "/skill/CSS-logo.png", "/skill/javascript-logo.png",],
      techNames: ["React JS", "Tailwind CSS", "JavaScript"],
      description: "Develop a responsive expense tracking website that is visually appealing, user-friendly, and helps users manage daily expenses efficiently. Built using React JS & Tailwind CSS.",
      live: "https://spendlens-eight.vercel.app",
      github: "https://github.com/magesh-frontend/spendlens"
    },
    {
      title: "ADVANCED TASK MANAGER",
      tech: ["/skill/HTML-Logo.png", "/skill/CSS-logo.png", "/skill/javascript-logo.png", "/skill/reactjs-logo.png"],
      techNames: ["HTML", "CSS", "JavaScript","React JS"],
      description: "Develop a static website that is visually appealing, user-friendly, static websites that deliver a seamless user experience. Using HTML & CSS for structure and styling,and JavaScript for interactivity.",
      live: "https://advanced-task-manager-4wd6.vercel.app/",
      github: "https://github.com/magesh-frontend/advanced-task-manager"
    },
  ],
  };
